var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5313 23.5313C65.4844 21.5781 65.4844 18.4062 63.5313 16.4531C61.5781 14.5 58.4062 14.5 56.4531 16.4531L40 32.9219L23.5312 16.4687C21.5781 14.5156 18.4062 14.5156 16.4531 16.4687C14.5 18.4219 14.5 21.5937 16.4531 23.5469L32.9219 40L16.4688 56.4687C14.5156 58.4219 14.5156 61.5938 16.4688 63.5469C18.4219 65.5 21.5937 65.5 23.5469 63.5469L40 47.0781L56.4688 63.5312C58.4219 65.4844 61.5938 65.4844 63.5469 63.5312C65.5 61.5781 65.5 58.4062 63.5469 56.4531L47.0781 40L63.5313 23.5313Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2ea249a99f5f8878aeebd0a654bbbac0.svg";
export { ForwardRef as ReactComponent };